import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
var NewSupplier = function () { return (_jsx(Navigate, { to: "/suppliers", replace: true, state: { openNewSupplier: true } })); };
export default NewSupplier;
